/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Send_Not_ConfiguredInputs */

const en_error_crm_send_not_configured = /** @type {(inputs: Error_Crm_Send_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sends are not set up in this environment yet.`)
};

/**
* | output |
* | --- |
* | "Sends are not set up in this environment yet." |
*
* @param {Error_Crm_Send_Not_ConfiguredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_send_not_configured = /** @type {((inputs?: Error_Crm_Send_Not_ConfiguredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Send_Not_ConfiguredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_send_not_configured(inputs)
});